import type { WhatsappNumber } from '@store/slices/settingsSlice.tsx';

export const pickCancellationWhatsapp = (
  numbers: WhatsappNumber[],
): WhatsappNumber | undefined =>
  numbers.find((entry) => Boolean(entry.phone_verified_at)) ?? numbers[0];

export const buildWhatsappHref = (
  entry: WhatsappNumber,
  message?: string,
): string | null => {
  const digits = entry.phone_e164.replace(/\D/g, '');
  if (!digits) return null;
  return `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
